import View from './view';
import React, {useCallback, useEffect, useState} from 'react';
import {IOwnProps} from './model';

export const Accordion: React.FC<IOwnProps> = (props) => {
  const [expanded, setExpanded] = useState(false);
  const variant = props.variant || 'filled';

  useEffect(() => {
    if (typeof props.expanded !== 'undefined') {
      setExpanded(props.expanded);
    }
  }, [props.expanded]);

  const handleChange = useCallback(() => {
    if (typeof props.expanded === 'undefined') {
      setExpanded(!expanded);
    }

    if (props.onChange) {
      props.onChange(!expanded);
    }
  }, [props.onChange, expanded]);

  return View({
    ...props,
    index: props.index,
    expanded,
    variant,
    onPress: handleChange,
  });
};
